import { getActiveTenantId } from "./authUtils";

export function getBackendUrl() {
  const raw = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");

  if (raw) {
    return raw.endsWith("/api") ? raw : `${raw}/api`;
  }

  return process.env.NODE_ENV === "development" ? "http://localhost:5001/api" : "/api";
}

export function extractErrorMessage(error, fallback = "An error occurred") {
  return (
    error?.response?.data?.details ||
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    fallback
  );
}

export function getAuthHeaders(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function buildScopedHeaders({
  token = null,
  chatbotId = null,
  publicBotId = null,
  publicVisitorToken = null,
  tenantId = null,
} = {}) {
  const isPublicRequest = Boolean(publicBotId || publicVisitorToken);
  const resolvedTenantId =
    !isPublicRequest
      ? (tenantId || getActiveTenantId({ token }))
      : null;

  const headers = {
    ...(publicVisitorToken
      ? { Authorization: `Bearer ${publicVisitorToken}` }
      : token
        ? { Authorization: `Bearer ${token}` }
        : {}),
    ...(!isPublicRequest && chatbotId ? { "X-Chatbot-Id": String(chatbotId) } : {}),
    ...(publicBotId ? { "X-Public-Bot-Id": String(publicBotId) } : {}),
    ...(resolvedTenantId ? { "X-Tenant-Id": String(resolvedTenantId) } : {}),
  };

  return headers;
}
